import { connect } from 'react-redux';
import { IState } from '../../store';
import { getLandStatusText } from '../../utils/land_status_text';
import { getHittingMicrodataExperiment } from '../../utils/microdata_experiment';
import {
  getCommercialBuildingClass,
  getGarageType,
  getPropertyType,
  mapAvailableFromToLocaleString,
} from '../../utils/offer_helpers';
import { getOfferType } from '../../utils/offer_type';
import { ParkingTypeNames } from '../../utils/parking_type_helpers';
import { descriptionConfig } from './config';
import { Description, IDescriptionProps } from './Description';
import {
  getSpecialties,
  getSpecialtyTitle,
  shouldSpecialtyRender,
  getDescriptionMicroData,
  shouldShowTitle,
} from './utils';

export const mapStateToProps = (state: IState): IDescriptionProps => {
  const { offer, businessShoppingCenter } = state.offerData;

  const {
    availableFrom,
    building,
    deadline,
    description,
    floorNumber,
    isOccupied,
    kitchenArea,
    land,
    livingArea,
    maxArea,
    minArea,
    roomArea,
    specialty,
    title,
    totalArea,
    category,
    areaParts,
    bargainTerms,
  } = offer;

  const fields = descriptionConfig[category] || [];

  const offerType = getOfferType(offer);
  const classType = getCommercialBuildingClass(building, businessShoppingCenter, true);
  const garageType = getGarageType(offer);
  const propertyType = getPropertyType(offer);

  let commercialLandType: string | undefined;

  if (land && land.status) {
    commercialLandType = getLandStatusText(land.status);
  }

  let availableData: string | undefined;

  if (availableFrom) {
    availableData = mapAvailableFromToLocaleString(availableFrom);
  }

  const isMicrodataExperimentEnable = getHittingMicrodataExperiment(state.experiments);
  const specialties = getSpecialties(specialty);
  const specialtiesString = specialties && specialties.specialtiesString;

  return {
    availableData,
    buildMaterialType: building && building.materialType,
    buildYear: building && building.buildYear,
    ceilingHeight: building && building.ceilingHeight,
    classType,
    columnGrid: building && building.columnGrid,
    commercialLandType,
    deadline,
    description,
    descriptionMicroData: getDescriptionMicroData(isMicrodataExperimentEnable),
    floorNumber,
    floorsCount: building && building.floorsCount,
    garageType,
    isOccupied,
    kitchenArea,
    landArea: land && land.area,
    landAreaUnitType: land && land.areaUnitType,
    landStatus: land && land.status,
    livingArea,
    maxArea,
    minArea,
    // FIXME: вынести формирование информации об объявлении в утилиту
    offerConfig: fields,
    offerType,
    parkingType: building && building.parking && building.parking.type && ParkingTypeNames[building.parking.type],
    possibleToChangeStatus: land && land.possibleToChangeStatus,
    propertyType,
    roomArea,
    specialtyPrepared: (shouldSpecialtyRender({ specialty, specialtiesString, offerType }) && specialties) || null,
    specialtyTitle: getSpecialtyTitle(offerType),
    title: (shouldShowTitle(offer) && title) || null,
    totalArea,
    areaParts,
    bargainTerms,
  };
};

export const DescriptionContainer = connect(mapStateToProps)(Description);
